<template>
  <div class="home-container">
    <div class="grid">
      <div class="hero-title">
        <h1>Custom Design Apparel</h1>
        <router-link to="/quote" class="CTA">Request a Quote</router-link>
      </div>
      <div class="hero-image">
        <img src="../assets/bg-head.webp" alt="Hero image" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.home-container {
  position: relative;
  padding: 1.5rem 1rem 2rem;
  max-width: 1300px;
  margin: 0 auto;
  background-image: url("../assets/bg-head.webp");
  background-position: top center;
  background-repeat: no-repeat;
  background-size: 90%;
  background-attachment: fixed;
  transition: all 0.25s ease-in-out;
}

.grid {
  display: grid;
  text-align: center;
  position: relative;
  grid-template-columns: repeat (12, 1fr);
}

.CTA {
  font-family: boombox, Helvetica, Arial, sans-serif;
  max-width: 350px;
  text-transform: uppercase;
  box-shadow: rgba(0, 0, 0, 0.17) 0px -23px 25px 0px inset,
    rgba(0, 0, 0, 0.15) 0px -36px 30px 0px inset,
    rgba(0, 0, 0, 0.1) 0px -79px 40px 0px inset, rgba(0, 0, 0, 0.06) 0px 2px 1px,
    rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px,
    rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px;
  background-color: #fa4349;
  color: #fff;
  padding: 12px 25px;
  border-radius: 22px;
  font-size: 0.85rem;
  transition: all 0.25s ease-in-out;
  text-transform: uppercase;
}

.CTA:hover {
  transform: scale(1.05);
}

.hero-title {
  text-transform: uppercase;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

h1 {
  font-size: 2.5rem;
  color: #fff;
  line-height: 1.5;
  text-align: center;
  margin-bottom: 1.5rem;
}
.hero-image img {
  display: none;
}

/* ----------------------------- Media------------------******************/
@media screen and (min-width: 500px) {
  h1 {
    margin-top: 2rem;
    font-size: 2.5rem;
    transition: all 0.25s ease-in-out;
  }
}
@media screen and (min-width: 768px) {
  h1 {
    font-size: 3rem;
    text-align: left;
    transition: all 0.25s ease-in-out;
  }
  .CTA {
    font-size: 1rem;
    transition: all 0.25s ease-in-out;
  }
  .grid {
    text-align: left;
    grid-template-columns: 2fr;
    grid-template-columns: 60% 40%;
    transition: all 0.25s ease-in-out;
  }
  .hero-image img {
    display: block;
    width: 100%;
    position: relative;
    right: 10%;
    top: 5%;
    transition: all 0.25s ease-in-out;
  }
  .home-container {
    padding: 1.5rem 1rem 2rem;
    margin: auto;
    overflow: hidden;
    background-image: none;
    transition: all 0.25s ease-in-out;
  }

  .hero-title {
    align-items: flex-start;
    justify-content: center;
    transition: all 0.25s ease-in-out;
  }
}
@media screen and (min-width: 768px) {
  .CTA {
    font-size: 1rem;
    transition: all 0.25s ease-in-out;
  }
}
</style>